<template>
  <div>
    <TeamProjectTable
      :isEditable="isUserInspectorOnProject"
      :members="members"
      :title="title"
      @edit-member-role="editMemberRole"
      @delete-member="deleteMember"
      @invite-members="inviteMembers"
    />

    <v-dialog
      v-model="openDialog"
      width="1000"
    >
      <TeamInvitation
        :title="titleInvitationDialog"
        @send-invites="sendInvites"
      />
    </v-dialog>
  </div>
</template>

<script>
import TeamService from "@/services/TeamService"
import TeamInvitation from "@/components/ri3/project/TeamInvitation.vue"
// import TeamTable from "@/components/ri3/project/TeamTable.vue"
import TeamProjectTable from "@/components/ri3/project/TeamProjectTable.vue"
import { isInspector } from "@/utils/middleware"

export default {
  name: "ProjectTeam",
  components: {
    TeamInvitation,
    TeamProjectTable
  },
  computed: {
    projectId() {
      return this.$store.state.app.project.id
    },
    isUserInspectorOnProject() {
      return isInspector(this.$store.state.app.project.role)
    },
    title() {
      return this.$t("views.team.title")
    },
    titleInvitationDialog() {
      return this.$t("views.team.invite_join", {
        entity: "espace evenementiel"
      })
    }
  },
  data() {
    return {
      members: [],
      openDialog: false
    }
  },
  mounted() {
    this.fetchMembers()
  },
  methods: {
    deleteMember(item) {
      TeamService.updateMemberRole(this, this.projectId, item.id, null).then(() => {
        this.fetchMembers()
      })
    },
    editMemberRole(item) {
      TeamService.updateMemberRole(this, this.projectId, item.id, item.role).then(() => {
        this.fetchMembers()
      })
    },
    fetchMembers() {
      this.loading = true
      TeamService.getTeam(this, this.projectId)
        .then(response => {
          this.members = response
        })
        .finally(() => {
          this.loading = false
        })
    },
    inviteMembers() {
      this.openDialog = true
    },
    sendInvites(invites) {
      TeamService.sendInvite(this, this.projectId, invites).then(() => {
        this.openDialog = false
      })
    }
  }
}
</script>
